import React from 'react';
import './App.css';
import PictureDropdown from './components/PictureDropdown';
import HeatmapDropdown from "./components/HeatmapDropdown";

import ClassRegistrationComponent from './components/ClassRegistrationComponent';

import banner from './gtg_banner.png'; // Import the banner picture
import background from './schematiq.png'; // Import the background image

function App() {
    const appStyles = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: `url(${background}) center/cover no-repeat fixed`, // Set the background image
    };

    return (
        <div className="App" style={appStyles}>
            <div>
                <ClassRegistrationComponent />
            </div>
            <div>
                <PictureDropdown />
            </div>
            <div>
                <HeatmapDropdown/>
            </div>
        </div>
    );
}

export default App;
